import React from 'react';
import { useSearchParams } from 'react-router-dom';

const CallPopup = ({ isPopupOpen, togglePopup }) => {
  const [searchParams] = useSearchParams();
  const adVersion = searchParams.get('ad'); // Check if 'ad' parameter exists

  // Different click IDs based on ad version
  const salesPhoneClickID = adVersion === 'new' ? 'sales-call-new-ad' : 'sales-call-default';
  const phoneLinkClickID = adVersion === 'new' ? 'phone-link-new-ad' : 'phone-link-default';

  // Function to log click ID when a phone link is clicked
  const handlePhoneClick = (clickID) => {
    console.log(`Phone number clicked with ID: ${clickID}`);
  };

  return (
    <>
      {isPopupOpen && (
        <div className="popup-overlay">
          <div className="popup-content">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/content-filter-154e4.appspot.com/o/assets%2Flogo_chris_2.jpg?alt=media&token=fe404c98-2c32-403c-8ddb-0c49d1b2f32f"
              alt="Logo"
              className="popup-logo"
            />
            <h2 className="popup-heading">Property Owners</h2>
            <p className="popup-subheading">Looking to sell or rent your property?</p>
            <p>
              <span className="popup-call-text">Call: </span>
              {/* Add unique click ID based on URL query parameter and log it */}
              <a
                href="tel:+441916941351"
                id={salesPhoneClickID}
                className="popup-phone-link"
                onClick={() => handlePhoneClick(salesPhoneClickID)} // Log the ID when clicked
              >
                0191 694 1351
              </a>
            </p>
            <hr className="popup-line-break" />
            <h2 className="popup-heading">Home Seekers</h2>
            <p className="popup-subheading">Searching for a home to buy or rent?</p>
            <p>
              <span className="popup-call-text">Call: </span>
              <a
                href="tel:+441913882151"
                id={phoneLinkClickID}
                className="popup-phone-link"
                onClick={() => handlePhoneClick(phoneLinkClickID)} // Log the ID when clicked
              >
                0191 388 2151
              </a>
            </p>
            <button className="close-popup-button" onClick={togglePopup}>
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default CallPopup;
